import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { BodyL, BrandXL } from '@sorare/core/src/atoms/typography';
import { cardPull as cardPullMessages } from '@sorare/core/src/lib/glossary';

import { SplashText } from '#src/components/essence/CardPullExperience/CardsReveal/SplashText/index.tsx';

import type { Shuffled_cardPull } from './__generated__/index.graphql.ts';

type Props = {
  cardPull: Nullable<Shuffled_cardPull>;
};

export const Shuffled = ({ cardPull }: Props) => {
  if (cardPull?.reshuffled) {
    return (
      <SplashText>
        <BrandXL color="var(--c-onBase-success)" className="text-center">
          <FormattedMessage {...cardPullMessages.shuffleClue} />
        </BrandXL>
        <BodyL className="text-center">
          <FormattedMessage defaultMessage="All revealed cards stay the same — they just change places." />
        </BodyL>
      </SplashText>
    );
  }

  return null;
};

Shuffled.fragments = {
  cardPull: gql`
    fragment Shuffled_cardPull on CardPull {
      id
      reshuffled
    }
  ` as TypedDocumentNode<Shuffled_cardPull>,
};
